import { TYPES_WITH_ELEVATED_LABEL, VALID_FALSY_VALUES } from './constants';

export const withElevatedType = type => type && TYPES_WITH_ELEVATED_LABEL.includes(type);

export const isValidFalsyValue = value => VALID_FALSY_VALUES.includes(value);
